import { isMobileDeviceDetectRegex } from './Validations';
import { generateBranchLinkAndRedirect, resetRedirectingFlag } from './branchIoUtils';
import { BRANCHIO_FEATURE_NAME, BRANCHIO_REDIRECTION_PATH_NAME } from './constant';

const isMobileDevice = () => {
  return isMobileDeviceDetectRegex;
};

export const handleLoginButtonNavigation = (e) => {
  if (isMobileDevice()) {
    e.preventDefault(); // Prevent default link behavior
    resetRedirectingFlag();
    generateBranchLinkAndRedirect(BRANCHIO_REDIRECTION_PATH_NAME.LOGIN, { feature: BRANCHIO_FEATURE_NAME.LOGIN });
  }
  // For desktop, let the default link behavior work
};

export const handleSignupButtonNavigation = (e) => {
  if (isMobileDevice()) {
    e.preventDefault(); // Prevent default link behavior
    resetRedirectingFlag();
    generateBranchLinkAndRedirect(BRANCHIO_REDIRECTION_PATH_NAME.SIGN_UP_AUTH, { feature: BRANCHIO_FEATURE_NAME.SIGN_UP });
  }
  // For desktop, let the default link behavior work
};